@if (!!url) {
  <a mat-list-item [routerLink]="url" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
    (click)="menuDrawer.toggle()" [disabled]="disabled" [class.disabled]="disabled">
    <div class="item-content">
      @if (!!icon) {
        @if (!isCustomIcon(icon)) {
          <mat-icon fontSet="material-icons-outlined">{{ icon }}</mat-icon>
        }
        @if (isCustomIcon(icon)) {
          <mat-icon [svgIcon]="icon"></mat-icon>
        }
      }
      <span>{{ text }}</span>
    </div>
  </a>
}

@if (!url) {
  <a mat-list-item (click)="menuDrawer.toggle()" [disabled]="disabled">
    <div class="item-content">
      @if (!!icon) {
        @if (!isCustomIcon(icon)) {
          <mat-icon fontSet="material-icons-outlined">{{ icon }}</mat-icon>
        }
        @if (isCustomIcon(icon)) {
          <mat-icon [svgIcon]="icon"></mat-icon>
        }
      }
      <span>{{ text }}</span>
    </div>
  </a>
}
